(function () {
  if (window.tutorialVideosInitialized) return;
  window.tutorialVideosInitialized = true;

  function stopDialogMedia(dialog) {
    dialog.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });

    dialog.querySelectorAll('iframe[data-src]').forEach(function (iframe) {
      iframe.removeAttribute('src');
    });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-tutorial-video-open]');

    if (openButton) {
      var dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;

      var iframe = dialog.querySelector('iframe[data-src]');
      if (iframe && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
      }

      dialog.showModal();

      var video = dialog.querySelector('video');
      if (video) video.play().catch(function () {});
      return;
    }

    var closeButton = event.target.closest('[data-tutorial-video-close]');
    if (closeButton) {
      var closeDialog = closeButton.closest('dialog');
      if (closeDialog) closeDialog.close();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.tagName === 'DIALOG') event.target.close();
  });

  document.addEventListener('close', function (event) {
    if (event.target.matches('.tutorial-videos__dialog')) {
      stopDialogMedia(event.target);
    }
  }, true);
})();

